<template>
  <div>
    <!-- 返回键 -->
    <div class="back" @click="backClick()">
      <i></i>
      <span>返回</span>
    </div>
    <!-- 试题得分详情 -->
    <div class="ItemDetails">
      <p class="text_p">
        <span>姓名：{{ this.$parent.examRow.UserName }}</span>
        <span>试卷名称：{{ this.$parent.examInfo.ExamName }} </span>
        <!-- 
        重新考试按钮 出现的条件是：
         1、考试结束时间未到
         2、考试未关闭
         3、还未结束考试的
       -->
        <el-button
          type="primary"
          icon="el-icon-refresh"
          v-if="buttonShow($parent.examInfo, $parent.examRow)"
          @click="dialogVisible = true"
          >重新考试</el-button
        >
      </p>
      <div class="firstTable">
        <el-table
          :data="infoData"
          border
          style="width: 100%"
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
            border: '1px solid #D8EDFFFF',
            textAlign: 'center',
          }"
        >
          <el-table-column label="题型" align="center" fixed>
            <template slot-scope="scope">
              {{ scope.row.topic }}
            </template>
          </el-table-column>

          <el-table-column
            v-for="(item, index) in infoFieldData"
            :key="index"
            :prop="item.prop"
            :label="
              item.Style +
              '（' +
              (item.Style == '总分' ? item.TotalScore : item.TestCount) +
              (item.Style == '总分' ? '分' : '题') +
              '）'
            "
            :width="item.width"
            align="center"
          >
            <template slot-scope="scope">
              <p v-if="index == 0" @click="fn(item)">
                {{ scope.row[index + 1] }}
              </p>
              <p v-if="index">{{ scope.row[index + 1] }}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 考试管理form -->
    <div class="mian" v-loading="loading">
      <h4>考生管理</h4>
      <div class="mian_form">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="全部试题" name="first" v-if="tabState">
            <div class="questionTable">
              <el-table
                :data="getData"
                style="width: 100%"
                :row-class-name="tableRowClassName"
              >
                <el-table-column width="80" label="序号">
                  <template slot-scope="scope">
                    <span>{{
                      (currentPage - 1) * pageSize + scope.$index + 1
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="(item, index) in formColumns"
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  :width="item.width"
                  height="150"
                  label-height="50"
                  align="center"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <p v-if="index == 0">{{ scope.row.PaperTestStyle }}</p>
                    <p v-if="index == 1">
                      <span
                        v-html="
                          referimg(scope.row.TestJSON, scope.row.PaperTestID)
                        "
                      ></span>
                      <!-- {{ scope.row.TestJSON }} -->
                    </p>
                    <p v-if="index == 2">
                      <span
                        v-html="
                          referimg(scope.row.Answer, scope.row.PaperTestID)
                        "
                      ></span>
                      <!-- {{ scope.row.Answer }} -->
                    </p>
                    <p v-if="index == 3">
                      {{
                        !scope.row.UserAnswer ? "未答" : scope.row.UserAnswer
                      }}
                    </p>
                    <p v-if="index == 4">{{ scope.row.Score }}</p>
                    <p v-if="index == 5">{{ scope.row.UserScore }}</p>
                    <p v-if="index == 6">
                      <span
                        v-if="scope.row.IsRight == 0"
                        style="color: green"
                        class="iconfont icon-dui"
                      ></span>
                      <span
                        v-else-if="scope.row.IsRight == 1"
                        style="color: red"
                        class="iconfont icon-cuo"
                      ></span>
                      <span v-else>未答</span>
                    </p>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <div class="foot_box">
                <div class="foot_pagetions">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="showpageindex"
                    :page-size="pageSize"
                    :page-sizes="pagesizesarr"
                    layout="prev, pager, next,sizes, jumper"
                    :total="total"
                    class="pagination"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="主观题批阅" name="second" v-if="tabState2">
            <template>
              <div class="btn_view" v-if="activeName == 'second'">
                <el-button type="primary" @click="defaultClick(0)"
                  >默认0分</el-button
                >
                <el-button type="primary" @click="defaultClick(1)"
                  >默认赋满分</el-button
                >
              </div>
            </template>

            <Second
              ref="stabe"
              :statePopupstatus="statePopupstatus"
              :students="students"
              :cutcoms="cutcoms"
              :backClick="backClick"
            />
          </el-tab-pane>
          <el-tab-pane label="错答试题" name="wrong" v-if="tabState3">
            <Wrong ref="wrong" :PaperModeExam="PaperModeExam"/>
          </el-tab-pane>
        </el-tabs>
        <!-- 2024/7/8 产品新增需求主观阅题增加两个默认按钮 -->
      </div>
    </div>
    <!-- 重新考试提醒弹窗 -->
    <div class="everywhere">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <p>
          注意！此操作不可逆，确认后此考生本场考试数据将被清除，考生须在规定的时间内重新参加考试。
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="sundflag" @click="dowmtest">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  studentExamInfo,
  studentExamTest,
  clearExamHistory,
  getPaperTest,
} from "@/services/examManager.js";
import loginvuex from "@/store/index";
import Second from "./Second.vue";
import Wrong from "./Wrong.vue";
export default {
  data() {
    return {
      setitme: "", //要被清除的定时器
      infoData: [], // 题型分值数据
      infoFieldData: [], // 题型分值字段
      row: {},
      tabState: true, // 选项卡状态判断
      tabState2: true, // 选项卡主观阅题状态判断
      tabState3: true, // 选项卡错题状态判断
      activeName: "first",
      currentPage: 1, //  当前页数
      showpageindex: 1, //显示的索引盒子
      pageSize: 10,
      pagesizesarr: [5, 10, 20, 50, 100],
      total: 100,
      loading: true,
      statePopupstatus: {}, //当前试卷行的信息
      students: {}, // 当前学生信息
      getData: [],
      dialogVisible: false, //重新考试弹窗
      sundflag: false, // 重新考试防抖
      PaperModeExam:null,
      formColumns: [
        {
          prop: "PaperTestStyle",
          label: "题型",
        },
        {
          prop: "TestJSON",
          label: "题干",
          width: "280px",
        },
        {
          prop: "Answer",
          label: "正确答案",
          width: "300px",
        },
        {
          prop: "UserAnswer",
          label: "考生答案",
        },
        {
          prop: "Score",
          label: "分值",
        },
        {
          prop: "UserScore",
          label: "得分",
        },
        {
          prop: "IsRight",
          label: "对错",
        },
      ],
    };
  },
  components: {
    Second,
    Wrong,
  },
  props: ["cutcoms"],
  methods: {
    backClick() {
      this.cutcoms(1);
      this.$destroy();
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    fn(item) {
      console.log(item);
    },
    // 显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.studentExamTests();
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.studentExamTests();
    },
    handleClick(tab, event) {
      if (tab.label === "全部试题") {
        // 之前采取点击就调用当前页面接口，不做缓存
        //  this.studentExamTests();
      } else if (tab.label === "主观题批阅") {
        // this.$refs.stabe.addTkjdTest();
      } else if (tab.label === "错答试题") {
        //  this.$refs.wrong.Multiple();
      }
    },
    // 重新考试
    async dowmtest() {
      this.sundflag = true;
      let params = {
        examID: this.$parent.examInfo.ExamID,
        studentID: this.$parent.examRow.UserID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      const { data } = await clearExamHistory(params);
      if (data.Status == 200) {
        this.$message.success("清除成功");
        //关闭弹窗
        this.dialogVisible = false;
        setTimeout(() => {
          this.cutcoms(1);
          this.sundflag = false;
        }, 500);
      } else {
        this.$message.error(data.Data);
        this.sundflag = false;
      }
    },

    async studentExamTests() {
      const type = this.$parent.examInfo.PaperMode;
      if (type === "random_difflever" || type === "unified_difflever") {
        // 难易度组卷
        const params = {
          examID: this.$parent.examInfo.ExamID,
          sudentUserID: this.$parent.examRow.UserID,
          pageIndex: this.currentPage - 1,
          eachPageNum: this.pageSize,
        };
        const { data } = await getPaperTest(params);
        console.log(data);
        if (data.Status === 200) {
          this.total = data.Data.count;
          this.getData = data.Data.allTest || [];
          this.getData = this.operateData(this.getData)
          setTimeout(() => {
            this.loading = false;
          }, 500);
        } else {
          this.$message.error(data.Msg);
        }
      } else {
        let params = {
          examID: this.$parent.examInfo.ExamID,
          sudentUserID: this.$parent.examRow.UserID,
          pageIndex: this.currentPage - 1,
          eachPageNum: this.pageSize,
          guid: JSON.parse(loginvuex.state.userlist).guid,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          hid: JSON.parse(loginvuex.state.hid),
        };
        const { data } = await studentExamTest(params);
        if (data.Status === 200) {
          this.total = data.Data.count;
          this.getData = data.Data.allTest || [];
          this.getData = this.operateData(this.getData)
          setTimeout(() => {
            this.loading = false;
          }, 500);
        } else {
          this.$message.error(data.Msg);
        }
      }
    },
    operateData(row) {
      const newarr = row.map((item) => {
        // 遍历去除[]
        item.UserAnswer = item.UserAnswer == false ? '':item.UserAnswer
        if (item.UserAnswer != null) {
          if (
            item.UserAnswer.indexOf("[") != "-1" &&
            item.UserAnswer.indexOf("]") != "-1" &&
            item.UserAnswer.indexOf('","') != "-1"
          ) {
            item.UserAnswer = this.safeJSONParse(item.UserAnswer.trim());
          } else if (
            item.UserAnswer.indexOf("[") != "-1" &&
            item.UserAnswer.indexOf("]") == "-1"
          ) {
            // 有用户奇葩自己输入一个[，直接当字符串处理
            // substring
            item.UserAnswer = item.UserAnswer.substring(
              1,
              item.UserAnswer.length
            );
          }
        }
        if (
          (item.PaperTestType == "XTEST" ||
            item.PaperTestType == "A3TEST" ||
            item.PaperTestType == "BTEST") &&
          item.Answer.length > 1
        ) {
          // A3 X B 题型且为多选题标准答案排序
          item.Answer = item.Answer.split("").sort().join("");
        }
        return item;
      });
      return newarr;
    },
    // 防止数据不对导致json解析不出来
    safeJSONParse(jsonString) {
      try {
        return JSON.parse(jsonString).join(",");
      } catch (error) {
        console.log("Invalid JSON format:", error);
        // 尝试手动提取有效的 JSON 键值对
        return jsonString;
      }
    },
    async ExamInfos() {
      let params = {
        examID: this.$parent.examInfo.ExamID,
        sudentUserID: this.$parent.examRow.UserID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      const { data } = await studentExamInfo(params);
      if (data.Status === 200) {
        let aa = data.Data.student[0];
        let bb = data.Data.paperStyle;

        let FieldData = [];
        let Data = [{ topic: "得分" }, { topic: "正确率" }];

        if (aa) {
          FieldData.push({
            Style: "总分",
            TotalScore: aa.TotalScore == null ? 0 : aa.TotalScore,
          });
          Data.forEach((element) => {
            if (element.topic === "得分") {
              if (aa.Score === null) {
                element["1"] = 0;
              } else {
                element["1"] = aa.Score;
              }
            } else {
              element["1"] = (aa.Percent * 100).toFixed(2) + "%";
            }
          });
        }

        if (bb.length > 0) {
          bb.forEach((element, index) => {
            FieldData.push({
              Style: element.Style,
              TotalScore: element.TotalScore,
              TestCount: element.TestCount,
            });
            if (element.UserScore === null) {
              element.UserScore = 0;
            }
            Data.forEach((element2) => {
              if (element2.topic === "得分") {
                element2[index + 2] = element.UserScore;
              } else {
                element2[index + 2] = (element.Percent * 100).toFixed(2) + "%";
              }
            });
          });
        }
        this.infoFieldData = FieldData;
        this.infoData = Data;
      } else {
        this.$message.error(data.Data);
      }
    },
    // 默认主观阅题分数
    defaultClick(type) {
      // console.log(this.$refs.stabe.getData1);
      this.$confirm(
        `此操作将主观阅题未批改默认为${type == 0 ? "0" : "满分"}, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          if (type == 0) {
            // 默认0分
            this.$refs.stabe.getData1 = this.$refs.stabe.getData1.map(
              (item) => {
                if (!item.input) {
                  item.input = 0;
                }
                return item;
              }
            );
          } else {
            // 默认满分
            this.$refs.stabe.getData1 = this.$refs.stabe.getData1.map(
              (item) => {
                if (!item.input) {
                  item.input = item.Score;
                }
                return item;
              }
            );
          }
        })
        .catch(() => {});
    },
    // 选项卡数据是否为空判断
    tabDataSatae() {
      if (this.$parent.isread == 1) {
        return; // 查看的时候只显示全部试题，这个时候拦截住
      }
      // 判断子组件列表放回空就把tab给删掉
      this.setitme = setTimeout(() => {
        if (this.$refs.stabe.getData1.length == 0) {
          this.tabState2 = false;
          // console.log("主观阅题要被清除掉了");
        } else if (this.$refs.wrong.allTest.length == 0) {
          this.tabState3 = false;
          // console.log("错杂题被清除掉了");
        }
      }, 100);
    },
    //        if (params.indexOf("[Img") == "-1") {
    //           return params;
    //         } else {
    //           let a = params.replace(
    //             /\[Img/g,
    //             "< img src='https://testimages.ksbao.com/tk_img/Img"
    //           );
    //           if (a.indexOf("~") != "-1") {
    //             let codeindex = a.lastIndexOf(".");
    //             a = a.replace(
    //               a[codeindex-1],
    //               '%'+a[codeindex - 1].charCodeAt().toString(16)
    //             );
    //           }
    //           return a.replace(/\]/g, "'>");
    //         }
  },
  computed: {
    //图片处理
    referimg() {
      return function (params, id) {
        if (!params) {
          return;
        }
        if (params.indexOf("[Img") == "-1") {
          return params;
        } else {
          let a = params.replace(
            /\[Img/g,
            "<img src='https://testimages.ksbao.com/tk_img/Img"
          );
          if (a.indexOf("~") != "-1") {
            let codeindex = a.lastIndexOf(".");
            a = a.replace(
              a[codeindex - 1],
              "%" + a[codeindex - 1].charCodeAt().toString(16)
            );
          }
          // 如果试卷ID超过或等于32位 http://customimgt.tibosi.com/hospitalID/XXX.gif
          if (String(id).length >= 32) {
            let imgurl = sessionStorage.getItem("ImgUrl"); // 图片正式还是测试地址
            a = params.replace(
              /\[Img/g,
              `<img src='${imgurl}/${JSON.parse(loginvuex.state.hid)}/`
            );
          }
          return a.replace(/\]/g, "'>");
        }
      };
    },
    buttonShow() {
      return function (row, user) {
        //   重新考试按钮 出现的条件是：
        //  1、考试结束时间未到
        //  2、考试未关闭
        //  3、还未结束考试的
        // let row = this.$parent.examInfo
        // AnIsPublish-->整场考试的状态   CurMode1当前考生的状态 IsLock 1==考场关闭
        if (row.AnIsPublish == "考试结束" || row.IsLock == 1) {
          return false; //  不显示
        } else {
          return true;
        }
      };
    },
  },
  async activated() {
    await this.studentExamTests();
    this.statePopupstatus = this.$parent.examInfo;
    this.students = this.$parent.examRow;
    this.tabDataSatae();
    this.ExamInfos(); // 上面卡片百分百之前在activated调用，删除了keep-alive
    // this.currentPage = 1;
    // if (this.$parent.isread === 0) {
    //   this.tabState = true;
    //   this.tabState2 = true;
    //   this.tabState3 = true;
    // } else if (this.$parent.isread === 1) {
    //   this.tabState = true; // 查看全部试题tab
    //   this.tabState2 = false; // 查看主观阅题tab
    //   this.tabState3 = false; // 查看错杂题tab
    // }
  },
  destroyed() {
    clearTimeout(this.setitme);
  },
  created() {
    this.PaperModeExam = this.$parent.examInfo.PaperModeExam // 试卷类型
    if (this.$parent.isread === 0) {
      this.tabState = true;
      this.tabState2 = true;
      this.tabState3 = true;
    } else if (this.$parent.isread === 1) {
      this.tabState = true; // 查看全部试题tab
      this.tabState2 = false; // 查看主观阅题tab
      this.tabState3 = false; // 查看错杂题tab
      // console.log("我是查看");
    }
  },
};
</script>

<style lang="scss" scoped>
.back {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.flex {
  display: flex;
  align-items: center;
}
.ItemDetails {
  background-color: white;
  border-top: 1px solid #eeeeee;
  .firstTable {
    margin-left: 24px;
    padding: 30px;
  }
  .text_p {
    display: flex;
  }
  span:nth-child(1) {
    min-width: 120px;
    height: 21px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 26px;
    color: #333333;
    opacity: 1;
    margin-left: 24px;
    margin-top: 35px;
    display: inline-block;
  }
  span:nth-child(2) {
    min-width: 180px;
    height: 21px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 26px;
    color: #333333;
    opacity: 1;
    margin-left: 30px;
    margin-top: 35px;
    display: inline-block;
  }
  ::v-deep .el-button {
    width: 115px;
    height: 40px;
    background: #64b5ff;
    opacity: 1;
    border-radius: 4px;
    margin-top: 25px;
    margin-left: 30px;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}
::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.mian {
  min-height: 500px;
  margin-top: 24px;
  border-radius: 10px !important;
  background: #ffffff;
  h4 {
    height: 66px;
    line-height: 66px;
    border: 1px solid #f8f8f8;
    padding-left: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    letter-spacing: 1px;
  }
  .mian_form {
    padding: 14px 24px;
    ::v-deep .el-tabs__nav {
      display: flex;
      border: 1px solid #1890ff;
    }
    ::v-deep .el-tabs__item {
      width: 180px;
      height: 50px;
      line-height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    ::v-deep .el-tabs--card > .el-tabs__header {
      display: flex;
      justify-content: flex-start !important;
    }
    ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
      border: 1px solid #1890ff;
      background: #1890ff;
      color: #ffffff;
    }
    ::v-deep .el-tabs--card > .el-tabs__header {
      border: none;
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
}
.questionTable {
  .el-button {
    font-size: 16px;
  }
  ::v-deep .el-table {
    margin-top: 10px;
  }
  ::v-deep .el-table th {
    width: 100%;
    height: 60px;
    background: #8fcbff;
    color: #333333;
    opacity: 1;
  }
  ::v-deep td > .cell {
    color: #999999;
    font-size: 15px;
  }
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(8) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}
::v-deep .el-table .cell {
  text-align: center !important;
}
// 弹窗样式
.everywhere {
  ::v-deep .el-dialog {
    width: 441px !important;
    height: 220px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    ) !important;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    button:nth-child(1) {
      margin-right: 50px;
    }
  }
  p {
    text-align: center;
    font-size: 16px;
  }
}
.btn_view {
  display: flex;
  align-items: center;
}
</style>
